
import { Provide, Component, Mixins } from 'vue-property-decorator';
import PartnerAssignCourseOperations from './AssignCourseOperations.vue';

@Component
export default class PartnerOperationApproval extends Mixins(PartnerAssignCourseOperations) {
    @Provide() public applyType: string = 'dropCourse';
}
